import { apiSlice } from '../../api';
import {
  CreateSandboxUserDTO,
  CreateSandboxUsersResult,
  DisableMerchantDTO,
  DisableMerchantResult,
  EnableMerchantDTO,
  EnableMerchantResult,
  GetProfileDTO,
  GetProfileResult,
  GetProfilesDTO,
  GetProfilesResult,
  GetProfileSumsubDataDTO,
  GetProfileSumsubDataResult,
  GetRoleResult,
  GetRolesDTO,
  GetSandboxUsersDTO,
  GetSandboxUsersResult,
  GetUsersDTO,
  GetUsersResult,
  UpdateProfileInfoDTO,
  UpdateProfileInfoResult,
  UpdateProfileProviderDTO,
  UpdateProfileProviderResult,
  UpdateProfileStatusDTO,
  UpdateProfileStatusResult,
} from './types';

export const adminProfilesEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getProfiles: build.query<GetProfilesResult, GetProfilesDTO>({
        query: ({ params }) => ({
          url: '/admin/v1/profiles',
          method: 'GET',
          params,
        }),
      }),

      getProfile: build.query<GetProfileResult, GetProfileDTO>({
        query: ({ profileUid }) => ({
          url: `/admin/v1/profiles/${profileUid}`,
          method: 'GET',
        }),
        providesTags: ['CurrentProfile'],
      }),

      updateProfileStatus: build.mutation<UpdateProfileStatusResult, UpdateProfileStatusDTO>({
        query: ({ profileUid, body }) => ({
          url: `/admin/v1/profiles/${profileUid}`,
          method: 'PATCH',
          body,
        }),
        invalidatesTags: ['CurrentProfile'],
      }),

      updateProfileInfo: build.mutation<UpdateProfileInfoResult, UpdateProfileInfoDTO>({
        query: ({ profileType, profileUid, body }) => ({
          url: `/admin/v1/profiles/${profileType}/${profileUid}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['CurrentProfile'],
      }),

      enableMerchant: build.mutation<EnableMerchantResult, EnableMerchantDTO>({
        query: ({ profileUid }) => ({
          url: `/admin/v1/profiles/${profileUid}/enable-merchant`,
          method: 'POST',
        }),
        invalidatesTags: ['CurrentProfile'],
      }),

      disableMerchant: build.mutation<DisableMerchantResult, DisableMerchantDTO>({
        query: ({ profileUid }) => ({
          url: `/admin/v1/profiles/${profileUid}/disable-merchant`,
          method: 'POST',
        }),
        invalidatesTags: ['CurrentProfile'],
      }),

      getProfileSumsubData: build.query<GetProfileSumsubDataResult, GetProfileSumsubDataDTO>({
        query: ({ profileUid }) => ({
          url: `/admin/v1/profiles/${profileUid}/sumsub/data`,
          method: 'GET',
        }),
      }),

      getRoles: build.query<GetRoleResult, GetRolesDTO>({
        query: () => ({
          url: '/admin/v1/roles',
          method: 'GET',
        }),
      }),

      getUsers: build.query<GetUsersResult, GetUsersDTO>({
        query: () => ({
          url: '/admin/v1/users',
          method: 'GET',
        }),
      }),

      getSandboxUsers: build.query<GetSandboxUsersResult, GetSandboxUsersDTO>({
        query: ({ profileUid }) => ({
          url: `/admin/v1/profiles/${profileUid}/sandbox-users`,
          method: 'GET',
        }),
      }),

      createSandboxUser: build.mutation<CreateSandboxUsersResult, CreateSandboxUserDTO>({
        query: ({ profile_uid, body }) => ({
          url: `/admin/v1/profiles/${profile_uid}/sandbox-users`,
          method: 'POST',
          body,
        }),
      }),

      updateProfiveProvider: build.mutation<UpdateProfileProviderResult, UpdateProfileProviderDTO>({
        query: ({ profile_uid, body }) => ({
          url: `/admin/v1/profiles/${profile_uid}/provider`,
          method: 'PUT',
          body,
          invalidatesTags: ['CurrentProfile'],
        }),
      }),
    };
  },
});

export const { useLazyGetProfilesQuery } = adminProfilesEndpoints;
export const { useGetProfileQuery, useLazyGetProfileQuery } = adminProfilesEndpoints;
export const { useUpdateProfileStatusMutation } = adminProfilesEndpoints;
export const { useUpdateProfileInfoMutation } = adminProfilesEndpoints;
export const { useGetProfileSumsubDataQuery } = adminProfilesEndpoints;
export const { useDisableMerchantMutation } = adminProfilesEndpoints;
export const { useEnableMerchantMutation } = adminProfilesEndpoints;
export const { useGetRolesQuery } = adminProfilesEndpoints;
export const { useGetUsersQuery } = adminProfilesEndpoints;
export const { useGetSandboxUsersQuery } = adminProfilesEndpoints;
export const { useCreateSandboxUserMutation } = adminProfilesEndpoints;
export const { useUpdateProfiveProviderMutation } = adminProfilesEndpoints;

export type AdminProfilesController = typeof adminProfilesEndpoints;
